import { track } from '@eventbrite/legacy-infra.datalayer-library';
import { Guide } from '@/src/homepage/types/guides';

type GuideTrackingData = {
    itListId: string;
    itListName: string;
    itListMarket: string;
    itListMarketId: string;
    itListAuthorId: string;
    itListAuthor: string;
};

export const SHARE_METHOD_MAP: Record<string, string> = {
    os: 'NativeShare',
    email: 'Email',
    facebook: 'Facebook',
    facebookmessenger: 'DirectMessage',
    linkedin: 'LinkedIn',
    twitter: 'Twitter',
    whatsapp: 'WhatsApp',
    copy: 'CopyUrl',
};

type TrackingObjectWithoutShare = {
    eventName: 'ViewSuggestedGuides' | 'ViewGuide' | 'ScreenView Guide' | 'ShareGuideAttempt';
    guide: Guide;
    shareType?: never;
};

type TrackingObjectWithShare = {
    eventName: 'ShareGuide';
    guide: Guide;
    shareType: string;
};

export const trackGuideEvent = (data: TrackingObjectWithoutShare | TrackingObjectWithShare) => {
    const { eventName, guide, shareType } = data;
    let additionalData = {};

    if (eventName === 'ShareGuide') {
        let shareMethod = SHARE_METHOD_MAP[shareType.toLowerCase()];
        if (!shareMethod && shareType) {
            shareMethod = 'Other';
        }
        additionalData = { shareMethod };
    }

    track({
        eventName,
        eventData: {
            ...getGuideTrackingData(guide),
            ...additionalData,
        },
    });
};

const getGuideTrackingData = (guide: Guide): GuideTrackingData => {
    const { guideId, name, owner, locations } = guide;

    return {
        itListId: guideId,
        itListName: name,
        itListMarket: locations?.length > 0 ? locations[0].displayName : 'Unknown',
        itListMarketId: locations?.length > 0 ? locations[0].id : 'Unknown',
        itListAuthorId: owner.profileId,
        itListAuthor: owner.displayName,
    };
};
